define.alias("shared/components/shared/upgrade/mobile-plan-card", "media/components/shared/upgrade/mobile-plan-card");